import { render, staticRenderFns } from "./resoure.vue?vue&type=template&id=55a2fb6b&"
import script from "./resoure.vue?vue&type=script&lang=js&"
export * from "./resoure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports